import { CardList } from '../../../../../../../commonComponents/CardList';
import { GroupList, GroupsHeader, GroupsSubHeader } from './components';

export const GroupsCard = () => (
  <CardList Header={GroupsHeader} SubHeader={GroupsSubHeader} List={GroupList} />
);
